import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import ScrollToTop from '@/components/shared/ScrollToTop/ScrollToTop.tsx';
import Header from '@/components/Header.tsx';
import Footer from '@/components/Footer.tsx';

const MainLayout: FC = () => {
  return (
    <>
      <ScrollToTop />
      <Header />
      <main
        id="app-main"
        className="bg-light-gray flex flex-col grow min-h-screen justify-start items-center p-4 md:p-8 overflow-auto"
      >
        <Outlet />
      </main>
      <section
        className="w-full"
        style={{
          background:
            'linear-gradient(160deg, #2d5a2d 0%, #336633 40%, #3f733f 60%, #336633 80%, #2d5a2d 100%)',
        }}
      >
        <div className="max-w-7xl xl:max-w-[1700px] mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-8 md:pt-16 md:pb-10">
          <Footer />
        </div>
      </section>
    </>
  );
};

export default MainLayout;
